import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledConfirmCancellation = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 40px;

  .confirm-header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    text-align: center;
  }

  .confirm-title {
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkGray};
    margin: 0;
  }

  .confirm-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
    width: 524px;
    margin: 0;

    .expiry-date {
      color: ${COLOR.functionalRed.default};
    }
  }

  .feedback-section {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .MuiOutlinedInput-root {
      border-radius: 12px;
      padding: 12px;
      font-size: 14px;

      textarea {
        padding: 0;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
      }
    }

    .input-label {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkGray};
      margin-bottom: 4px;
    }
  }

  .cta-row {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    .confirm-title {
      font-size: 24px;
    }

    .confirm-description {
      width: 100%;
    }

    .cta-row {
      justify-content: stretch;

      .MuiButtonBase-root {
        width: 100%;
      }
    }
  }
`;
